const languageMeta = {
  en: { label: 'English', dir: 'ltr' },
  pt: { label: 'Portugues', dir: 'ltr' },
  es: { label: 'Español', dir: 'ltr' },
  it: { label: 'Italiano', dir: 'ltr' },
  tr: { label: 'Türkçe', dir: 'ltr' },
  ar: { label: 'العربية', dir: 'rtl' },
  zh: { label: '中文', dir: 'ltr' },
};

export const defaultLanguage = 'en';

export default languageMeta;
